import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import {
  Content, ContainerAlt, Title, Description, Footer, RightButton, LeftButton,
} from './common/styles';
import Available from './holdings-elements/available';
import Following from './holdings-elements/following';
import { setHoldingsOptOut } from '../../services/onboarding-services';

const OddButton = styled(LeftButton)`
  color: ${props => props.theme.secondaryColor};
  ${props => (!props.theme.isMobile && `
    align-self: flex-end;
    position: relative;
    top: 68px;
    background-color: transparent;
  `)}
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: -2vh;
`;

const HangingContent = styled(Content)`
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  ${props => (!props.theme.isMobile && `
    height: 300px;
  `)}
`;

const HFlex = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const SkipButton = ({ onClick }) => <OddButton type="button" onClick={onClick}>skip</OddButton>;
SkipButton.propTypes = { onClick: PropTypes.func.isRequired };

const BackButton = ({ text, onClick }) => (
  <LeftButton type="button" onClick={onClick}>{text}</LeftButton>
);
BackButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default function Holdings({ previousStep, redirectToUrl }) {
  const { isMobile } = React.useContext(ThemeContext);
  const setOptOut = (event, value) => {
    event.preventDefault();

    setHoldingsOptOut(value).then(() => {
      window.location.replace(`onboarding/contributors?redirect_to=${redirectToUrl}`);
    });
  };

  const finish = e => {
    setOptOut(e, false);
  };

  const skip = e => {
    setOptOut(e, true);
  };

  return (
    <ContainerAlt>
      <Title>
        Stay Updated: Follow Your Favourite Equities, ETFs & LICs for Latest News
      </Title>
      <Description>
        Start following equities, ETFs and LICs you’re interested in and we’ll notify you
        via email any related content that has been published. Manage items easily from
        My Follows within your profile settings.
      </Description>
      { !isMobile && (
        <Container>
          <BackButton text="back" onClick={previousStep} />
          <HangingContent>
            <Available />
            <Following />
          </HangingContent>
          <RightButton type="button" onClick={finish}>Next</RightButton>
        </Container>
      )}
      { !!isMobile && (
        <HangingContent>
          <Available />
          <Following />
        </HangingContent>
      )}
      { !!isMobile && (
        <Footer>
          <RightButton type="button" onClick={finish}>Next</RightButton>
          <HFlex>
            <BackButton text="go back" onClick={previousStep} />
            <SkipButton onClick={skip} />
          </HFlex>
        </Footer>
      )}
      {!isMobile && <SkipButton onClick={skip} />}
    </ContainerAlt>
  );
}

Holdings.propTypes = {
  previousStep: PropTypes.func.isRequired,
  redirectToUrl: PropTypes.string.isRequired,
};
